var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeMaison(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_6496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1206 12.0915L22.021 1.04619C20.2429 -0.348729 17.7571 -0.348729 15.979 1.04619L1.87942 12.0915C0.685583 13.0289 0 14.4349 0 15.9533V38.0028H38V15.9533C38 14.4364 37.3144 13.0289 36.1206 12.0915ZM34.8333 34.8361H3.16667V15.9533C3.16667 15.4229 3.41525 14.9114 3.83167 14.5837L17.9328 3.53835C18.5598 3.04594 19.437 3.04435 20.0672 3.53835L34.1668 14.5853C34.5848 14.913 34.8333 15.4244 34.8333 15.9549V34.8361ZM22.5308 14.2528C21.1217 14.2528 19.8787 14.7563 18.9683 15.6018C18.0579 14.7579 16.815 14.2528 15.4058 14.2528C12.5685 14.2528 10.26 16.6895 10.26 19.6836C10.26 24.4051 17.2663 29.4069 18.0658 29.961L18.9683 30.588L19.8708 29.961C20.6704 29.4069 27.6767 24.4051 27.6767 19.6836C27.6767 16.6879 25.3682 14.2528 22.5308 14.2528ZM18.9699 26.6946C16.7311 24.9529 13.4267 21.7926 13.4267 19.6836C13.4267 18.4344 14.3149 17.4194 15.4058 17.4194C16.3178 17.4194 17.385 17.9198 17.385 19.3337H17.4167V20.5861H20.5833V19.0028H20.5754C20.7274 17.9119 21.6331 17.4194 22.5324 17.4194C23.6233 17.4194 24.5116 18.4359 24.5116 19.6836C24.5116 21.6454 21.5175 24.7281 18.9715 26.6946H18.9699Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_6496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeMaison);
export default __webpack_public_path__ + "static/media/type_maison.3b753bf08911aba1fcbd8eb84284bf86.svg";
export { ForwardRef as ReactComponent };